import { Component, OnChanges, Input } from '@angular/core';
import { InprocessQualityIssues, IQIToken, IQIDayToken, DailyTokenItem, DailyToken } from '../../shared/misc-classes';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';

@Component({
  selector: 'app-inprocess-qual',
  templateUrl: './inprocess-qual.component.html',
  styleUrls: ['./inprocess-qual.component.css']
})
export class InprocessQualComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() inProcessQualObj:InprocessQualityIssues;  
  IQIDayTokenObj:IQIDayToken;
  constructor(private _dataService:DataService) { }

  ngOnChanges() {
    this.loadDateData()
  }
  getProductName(_prodId:string):string{
    if(_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }
  getData(option){
    if(option) return option
    return ''
 }
 getResponsiblePrsn(_prsn:string):string{
   if(_prsn) return this._dataService.getResponsiblePrsn(_prsn); 
   return ''
 }
  loadDateData():void{
    if(this.inProcessQualObj){
      let _tmpDPHDayToken:IQIDayToken = this.inProcessQualObj.getDateToken(this.currMonthDtObj);
      if(_tmpDPHDayToken == null){
        this.inProcessQualObj.addDateToken(this.currMonthDtObj);  
        _tmpDPHDayToken = this.inProcessQualObj.getDateToken(this.currMonthDtObj);
      }
      this.IQIDayTokenObj = _tmpDPHDayToken;
    }else{
      this.IQIDayTokenObj = new IQIDayToken(this.currMonthDtObj,[])
    }
    
  }

}
